import React from 'react';

import { useIntl } from '../../../../util/reactIntl';

import { NamedLink } from '../../../../components';

import EditorialCard from './EditorialCard/EditorialCard';
import { editorials } from '../../../../config/editorials';

import css from './SectionEditorial.module.css';

// The homepage is a teaser, /magasin is the archive. Two cards fill the grid's
// one row; a third sat alone on a second row the day the photo guide went up,
// and looked like a mistake. "Vis alle →" is where the rest live.
const HOMEPAGE_CARDS = 2;

/**
 * "Inspirasjon & innsikt" landing section.
 *
 * Reads the editorial articles straight from `src/config/editorials.js`
 * so the landing cards stay in sync with the Magasin pages, and shows the
 * newest HOMEPAGE_CARDS of them — the list is kept newest first. The
 * "Vis alle →" link points at `/magasin`.
 *
 * @returns {JSX.Element|null}
 */
const SectionEditorial = () => {
  const intl = useIntl();

  if (editorials.length === 0) return null;
  const featured = editorials.slice(0, HOMEPAGE_CARDS);

  return (
    <section className={css.root}>
      <div className={css.header}>
        <h3 className={css.title}>
          {intl.formatMessage({ id: 'SectionEditorial.title' })}
        </h3>
        <NamedLink className={css.viewAll} name="MagasinPage">
          {intl.formatMessage({ id: 'SectionEditorial.viewAll' })}
        </NamedLink>
      </div>

      <div className={css.grid}>
        {featured.map(editorial => (
          <EditorialCard key={editorial.slug} editorial={editorial} />
        ))}
      </div>
    </section>
  );
};

export default SectionEditorial;
